import { clientFor } from '@yc/api-client'

const api = clientFor('/pod/api')

/** 工作台 KPI：与后端 internal/home/service.go 的 Stats 的 JSON 字段一一对应 */
export interface HomeStats {
  /** 运单总数 */
  total_shipments: number
  /** 在途的运单数 */
  in_transit: number
  /** 已到达、等签收的运单数 */
  arrived: number
  /** 今天签满结单的运单数 */
  signed_today: number
  /** 还没关掉的签收异常数 */
  open_exceptions: number
  /** 等着提交的回单数 */
  pending_receipts: number
}

export const getHomeStats = (): Promise<HomeStats> => api.get<HomeStats>('/home/stats')
